import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NumberReservationService {
  constructor() { }

  reserveNumber(p0: string): Observable<string> {
    // Generate a mock number
    const mockNumber = Math.floor(Math.random() * 1000000).toString().padStart(6, '0');
    return of(mockNumber);
  }
}